var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyHomePage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_38611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 12.4993H3.33317C2.89114 12.4993 2.46722 12.3238 2.15466 12.0112C1.8421 11.6986 1.6665 11.2747 1.6665 10.8327V3.33268C1.6665 2.89065 1.8421 2.46673 2.15466 2.15417C2.46722 1.84161 2.89114 1.66602 3.33317 1.66602H10.8332C11.2752 1.66602 11.6991 1.84161 12.0117 2.15417C12.3242 2.46673 12.4998 2.89065 12.4998 3.33268V4.16602M9.1665 7.49935H16.6665C17.587 7.49935 18.3332 8.24554 18.3332 9.16602V16.666C18.3332 17.5865 17.587 18.3327 16.6665 18.3327H9.1665C8.24603 18.3327 7.49984 17.5865 7.49984 16.666V9.16602C7.49984 8.24554 8.24603 7.49935 9.1665 7.49935Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_38611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyHomePage);
export default __webpack_public_path__ + "static/media/copy_home_page.4fe48176b306f304813f50d40193eb0a.svg";
export { ForwardRef as ReactComponent };